<script setup lang="ts">
const { article } = defineProps<{
  article: string
}>()

const item = ref()
const blogApi = useStoryblokBlog()
const blogArticle = await blogApi.getArticles(1, undefined, { by_uuids: article })

if (blogArticle)
  item.value = blogArticle[0]
</script>

<template>
  <div class="mx-auto flex flex-col md:items-center">
    <BlogArticleItem :item="item" />
  </div>
</template>

<style lang="scss" scoped></style>
